import ctl from "@netlify/classnames-template-literals";
import React from "react";
import NombaGif from "assets/images/gifs/Nomba.gif";

const NombaLoader = () => {
  return (
    <div className={nombaLoaderStyle}>
      <img
        src={NombaGif}
        alt="Loading"
        style={{ width: "5%", height: "fit-content" }}
      />
    </div>
  );
};

const nombaLoaderStyle = ctl(`
flex
align-center;
items-center
justify-center
h-[100vh]
w-[100%]

`);

export { NombaLoader };
